import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import '../../assets/css/navbar.scss'
import companyLogo from '../../assets/images/signin/logo-dark.png'
import profileImg from '../../assets/images/dashboard/profileImg.jpg'
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { ClearBtn, SearchBtn } from '../Buttons/Buttons';
import logOutImg from '../../assets/images/signin/log_out.png'
import { useDispatch, useSelector } from 'react-redux';
import { connectAiApp, getFirstLoginStatus, loadCreditsData, logoutFunction, setAIFreameWork, setAiLoader, setAiModal } from '../redux/action';
import * as HeaderAuthentication from '../HeaderAuthentication';
import { useLocation, useNavigate } from 'react-router-dom';
import { useRef } from 'react';

const AppNavbar = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
    const { isAiOpen } = useSelector(state => state.data);
    const { aiFrameWork } = useSelector(state => state.data);

    const [firstStep, setFirstStep] = useState(true);
    const [secondStep, setSecondStep] = useState(false);

    const roles = signInDetails[0]?.role;
    const { loginStatus } = useSelector(state => state.data);

    const { getCredits } = useSelector(state => state.data);

    const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
    const [showProfileDropdown, setShowProfileDropdown] = useState(false);
    const [showSearchDropdown, setShowSearchDropdown] = useState(false);
    const [showReportDropdown, setShowReportDropdown] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    const [modalShow, setModalShow] = useState(false);
    const hasRun = useRef(false);

    useEffect(() => {
        const container = document.querySelector(".page-content");

        const handleScroll = () => {
            setIsScrolled(container.scrollTop > 20);
        };

        container?.addEventListener("scroll", handleScroll);

        return () => {
            container?.removeEventListener("scroll", handleScroll);
        };
    }, []);

    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;
        dispatch(loadCreditsData(signInDetails[0]?.sbn_id, signInDetails[0]?.id))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleToggle = (e) => {
        // dispatch(setAiModal(false))
        setShowSettingsDropdown((prev) => !prev);
        setShowProfileDropdown(false);
    };

    const handleProfileToggle = (e) => {
        setShowProfileDropdown(prev => !prev);
        setShowSettingsDropdown(false);
    };

    const logOutPage = () => {

        const logout_body = {
            "user_id": parseInt(signInDetails[0]?.id),
            "session_id": signInDetails[0]?.session_id
        }
        const logout_post = {
            method: 'POST',
            mode: 'cors',
            headers: HeaderAuthentication.postAuthOfLeadMerge,
            body: JSON.stringify(logout_body),
        }
        dispatch(logoutFunction(logout_post));
    }

    const handleModalClose = () => {
        setModalShow(false);
    }
    const openLoguutModal = () => {
        setModalShow(true);
    }
    const [isFullScreen, setIsFullScreen] = useState(false);
    const toggleFullScreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().then(() => setIsFullScreen(true));
        } else {
            document.exitFullscreen().then(() => setIsFullScreen(false));
        }
    };

    // region  connect lead genix application
    const connectAI = () => {
        dispatch(setAiLoader(true))
        console.log(signInDetails, "signInDetails")

        if (Object.keys(aiFrameWork).length !== 0) {
            dispatch(setAiModal(true))
            console.log(aiFrameWork)
            document.getElementById("main_app").style.display = "flex";
            document.getElementById("aiSidebar").style.display = "block";
            document.getElementById("aiFrame").src =
                aiFrameWork.embed_url;
            setTimeout(() => {
                dispatch(setAiLoader(false))
            }, 500)
        } else {

            const userData = {
                project_id: "data_leadmerge",
                user_id: signInDetails[0]['id'],
                name: signInDetails[0]['name'],
                email: signInDetails[0]['email']
            };

            const logout_post = {
                method: 'POST',
                mode: 'cors',
                headers: HeaderAuthentication.postAuthOfLeadMerge,
                body: JSON.stringify(userData),
            }

            dispatch(connectAiApp(logout_post)).then((
                data
            ) => {
                console.log(data, "resp")
                if (data.status) {

                    dispatch(setAIFreameWork(data))

                    document.getElementById("main_app").style.display = "flex";
                    document.getElementById("aiSidebar").style.display = "block";
                    document.getElementById("aiFrame").src =
                        data.embed_url;
                    setTimeout(() => {
                        dispatch(setAiLoader(false))
                    }, 1000)
                }
            }
            )
        }
    }
    // endregion

    // region function to upgrade the pan
    const upgradePlan = () => {
        navigate("/upgrade_plan")
    };
    // endregion

    const navigateToHome = () => {
        dispatch(setAiModal(false))
        navigate("/")
    }

    const isActive = (paths) => {
        return paths.includes(location.pathname);
    };

    const clearGuideSesion = () => {
        dispatch(getFirstLoginStatus(false))
    }

    return (
        <>
            <Navbar expand="lg" className={`navabar-container ${isScrolled ? "navabar-scrolled" : ""} ${loginStatus && "navabar-container-focus"} ${isAiOpen && "ai-open"}`} style={{ width: isAiOpen ? "60% !important" : "100%" }}>
                {loginStatus && <div className="guide-overlay-navbar"></div>}
                <Container fluid>
                    <Navbar.Brand onClick={navigateToHome} className="navbar-logo"><img src={companyLogo} alt="" className='logo-img' /></Navbar.Brand>
                    {/* <Navbar.Toggle aria-controls="navbarScroll" /> */}
                    {isAiOpen ? (
                        <button
                            className="navbar-toggler d-flex"
                            type="button"
                            onClick={() => dispatch(setAiModal(false))}
                        >
                            <span className="navbar-toggler-icon"></span>
                        </button>
                    ) : (
                        <Navbar.Toggle aria-controls="navbarScroll" />
                    )}
                    {!isAiOpen && (
                        <Navbar.Collapse id="navbarScroll" className={`nav-collapse`}>

                            <Nav
                                className="nav-collapse-first-div"
                                // style={{ maxHeight: "100px" }}
                                navbarScroll
                            >
                                <Nav.Link
                                    onClick={() => { navigate("/dashboard"); dispatch(setAiModal(false)) }}
                                    className={isActive(["/dashboard", "/"]) ? "active-nav" : ""}
                                >
                                    <i className='bx bx-home-alt me-2'></i>
                                    Home
                                </Nav.Link>

                                <NavDropdown
                                    title={
                                        <span className="menu-title">
                                            <i className='bx bx-search-alt-2'></i>
                                            Search

                                            {(loginStatus && firstStep && location.pathname !== "/contact-filter") &&
                                                <div className="guide-tooltip step1-tooltip">
                                                    <div className="guide-badge">
                                                        Step 1 of 6
                                                    </div>

                                                    <h6>Find Your Contacts</h6>

                                                    <p>
                                                        Click on <b>Search</b> to discover verified leads and
                                                        build your prospect lists.
                                                    </p>

                                                    <div className="guide-footer">
                                                        <button
                                                            className="guide-skip-btn"
                                                            onClick={clearGuideSesion}
                                                        >
                                                            Skip
                                                        </button>

                                                        <button
                                                            className="guide-next-btn"
                                                            onClick={() => {
                                                                setFirstStep(false);
                                                                setSecondStep(true);
                                                                setShowSearchDropdown(true);
                                                            }}
                                                        >
                                                            Got It
                                                        </button>
                                                    </div>
                                                </div>}

                                            {loginStatus && secondStep && (
                                                <div className="contact-guide-wrapper">
                                                    <div className="guide-hand">
                                                        👆
                                                    </div>

                                                    <div className="guide-card">
                                                        <div className="guide-badge">
                                                            Step 2 of 6
                                                        </div>

                                                        <h5>Search Contacts</h5>

                                                        <p>
                                                            Click on <b>Contacts</b> to search millions of
                                                            verified B2B contacts using advanced filters.
                                                        </p>

                                                        <div className="guide-footer">
                                                            <button
                                                                className="guide-skip-btn"
                                                                onClick={clearGuideSesion}
                                                            >
                                                                Not Now
                                                            </button>

                                                            <button
                                                                className="guide-next-btn"
                                                                onClick={() => {
                                                                    setSecondStep(false);
                                                                    navigate("/contact-filter");
                                                                }}
                                                            >
                                                                Next →
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                        </span>
                                    }
                                    id="searchDropdown"
                                    show={showSearchDropdown}
                                    // onMouseEnter={() => setShowSearchDropdown(true)}
                                    // onMouseLeave={() => setShowSearchDropdown(false)}
                                    onToggle={(isOpen) => {
                                        setFirstStep(false);
                                        setSecondStep(true);
                                        setShowSearchDropdown(true);
                                        // setShowSearchDropdown(isOpen);
                                    }}
                                    onMouseEnter={() => {
                                        if (!loginStatus && !firstStep) {
                                            setShowSearchDropdown(true);
                                        }
                                    }}
                                    onMouseLeave={() => {
                                        if (!loginStatus && !firstStep) {
                                            setShowSearchDropdown(false);
                                        }
                                    }}
                                    className={`custom-nav-dropdown ${(loginStatus && (firstStep || secondStep) && location.pathname !== "/contact-filter") && "guide-focus"} ${isActive([
                                        "/contact-filter",
                                        "/saved-searches",
                                        "/viewed-contacts",
                                    ])
                                        ? "active-dropdown"
                                        : ""
                                        }`}
                                >

                                    <div className='custom-drop-section'>
                                        {loginStatus && <div className="guide-overlay-navbar-custom"></div>}

                                        <div className="dropdown-section-header">
                                            <h6>Lead Discovery</h6>
                                            <span>Search and manage your prospects</span>
                                        </div>


                                        <NavDropdown.Item
                                            active={location.pathname === "/contact-filter"}
                                            onClick={() => { navigate("/contact-filter"); setSecondStep(false); dispatch(setAiModal(false)) }}
                                            className="mega-menu-item guide-contact-highlight"
                                        >
                                            <div className="menu-icon">
                                                <i className='bx bx-user-circle'></i>
                                            </div>

                                            <div className="menu-content">
                                                <div className="menu-header">
                                                    <h6>Contacts</h6>
                                                    <span className="menu-badge">Popular</span>
                                                </div>

                                                <p>
                                                    Search millions of verified B2B contacts.
                                                </p>
                                            </div>
                                        </NavDropdown.Item>

                                        {roles?.toLowerCase() !== "b2buser" && (
                                            <>
                                                <NavDropdown.Item
                                                    active={location.pathname === "/saved-searches"}
                                                    onClick={() => { navigate("/saved-searches"); dispatch(setAiModal(false)) }}
                                                    className="mega-menu-item"
                                                >
                                                    <div className="menu-icon">
                                                        <i className='bx bx-bookmark-heart'></i>
                                                    </div>

                                                    <div className="menu-content">
                                                        <h6>Saved Search Criteria</h6>

                                                        <p>
                                                            Quickly access your saved search criteria.
                                                        </p>
                                                    </div>
                                                </NavDropdown.Item>

                                                <NavDropdown.Item
                                                    active={location.pathname === "/viewed-contacts"}
                                                    onClick={() => { navigate("/viewed-contacts"); dispatch(setAiModal(false)) }}
                                                    className="mega-menu-item"
                                                >
                                                    <div className="menu-icon">
                                                        <i className='bx bx-history'></i>
                                                    </div>

                                                    <div className="menu-content">
                                                        <h6>Viewed Contacts</h6>

                                                        <p>
                                                            Review recently viewed leads and profiles.
                                                        </p>
                                                    </div>
                                                </NavDropdown.Item>
                                            </>
                                        )}
                                    </div>
                                </NavDropdown>


                                {/* {roles?.toLowerCase() === "super_admin" && (
                                    <NavDropdown
                                        title={
                                            <span className="menu-title">
                                                <i className='bx bx-line-chart'></i>
                                                Reports
                                            </span>
                                        }
                                        id="reportDropdown"
                                        show={showReportDropdown}
                                        onMouseEnter={() => setShowReportDropdown(true)}
                                        onMouseLeave={() => setShowReportDropdown(false)}
                                        className={`custom-nav-dropdown ${isActive([
                                            "/subscriptions",
                                            "/payment_history",
                                            "/user_activity",
                                        ])
                                            ? "active-dropdown"
                                            : ""
                                            }`}
                                    >
                                        <div className="dropdown-section-header">
                                            <h6>Subscription & User Analytics</h6>
                                            <span>Monitor subscriptions, payments, and user engagement</span>
                                        </div>

                                        <NavDropdown.Item
                                            active={location.pathname === "/subscriptions"}
                                            onClick={() => {
                                                navigate("/subscriptions");
                                                dispatch(setAiModal(false));
                                            }}
                                            className="mega-menu-item"
                                        >
                                            <div className="menu-icon">
                                                <i className="bx bx-credit-card-front"></i>
                                            </div>

                                            <div className="menu-content">
                                                <div className="menu-header">
                                                    <h6>Subscription Data</h6>
                                                    <span className="menu-badge">Live</span>
                                                </div>

                                                <p>
                                                    View active plans, subscription trends, and customer insights.
                                                </p>
                                            </div>
                                        </NavDropdown.Item>

                                        <NavDropdown.Item
                                            active={location.pathname === "/payment_history"}
                                            onClick={() => {
                                                navigate("/payment_history");
                                                dispatch(setAiModal(false));
                                            }}
                                            className="mega-menu-item"
                                        >
                                            <div className="menu-icon">
                                                <i className="bx bx-wallet-alt"></i>
                                            </div>

                                            <div className="menu-content">
                                                <h6>Payment History</h6>

                                                <p>
                                                    Track transactions, invoices, refunds, and revenue history.
                                                </p>
                                            </div>
                                        </NavDropdown.Item>

                                        <NavDropdown.Item
                                            active={location.pathname === "/user_activity"}
                                            onClick={() => {
                                                navigate("/user_activity");
                                                dispatch(setAiModal(false));
                                            }}
                                            className="mega-menu-item"
                                        >
                                            <div className="menu-icon">
                                                <i className="bx bx-user-pin"></i>
                                            </div>

                                            <div className="menu-content">
                                                <h6>User Activity</h6>

                                                <p>
                                                    Monitor logins, searches, feature usage, and user engagement.
                                                </p>
                                            </div>
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                )} */}

                                {(roles?.toLowerCase() === "admin" ||
                                    roles?.toLowerCase() === "user") && (
                                        <Nav.Link
                                            onClick={() => { navigate("/my-list"); dispatch(setAiModal(false)) }}
                                            className={isActive(["/my-list"]) ? "active-nav" : ""}
                                        >
                                            <i className='bx bx-list-ul me-2'></i>
                                            My List
                                        </Nav.Link>
                                    )}
                            </Nav>
                            <div className='nav-collapse-second-div'>
                                {getCredits.credits_aval < 25 && <button onClick={upgradePlan} id="connectAiBtn">
                                    Upgrade Plan
                                </button>}
                                {getCredits.credits_aval && <p className='credits-count'>{getCredits.credits_aval} credits</p>}
                                <i className={`bx ${isFullScreen ? "bx-exit-fullscreen" : "bx-fullscreen"} fl-icon`}
                                    onClick={toggleFullScreen}
                                    style={{ cursor: "pointer", fontSize: "20px" }}
                                    title={isFullScreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                                ></i>

                                <Nav.Link onClick={handleToggle} className='settings-nav-link'>
                                    <i className='fa fa-gear settings-icon' />
                                </Nav.Link>
                                <NavDropdown
                                    title=""
                                    id="navbarScrollingDropdown"
                                    className='settingsNavDropdown'
                                    show={showSettingsDropdown}
                                    onMouseLeave={() => setShowSettingsDropdown(false)}
                                >
                                    {(roles?.toLowerCase() === "super_admin") && (
                                        <>
                                            <div className="dropdown-section-header">
                                                <h6>Subscription & User Analytics</h6>
                                                <span>Monitor subscriptions, payments, and user engagement</span>
                                            </div>

                                            {/* Subscription Data */}
                                            <NavDropdown.Item
                                                active={location.pathname === "/subscriptions"}
                                                onClick={() => {
                                                    navigate("/subscriptions");
                                                    dispatch(setAiModal(false));
                                                }}
                                                className="mega-menu-item"
                                            >
                                                <div className="menu-icon">
                                                    <i className="bx bx-credit-card-front"></i>
                                                </div>

                                                <div className="menu-content">
                                                    <div className="menu-header">
                                                        <h6>Subscription Data</h6>
                                                        <span className="menu-badge">Live</span>
                                                    </div>

                                                    <p>
                                                        View active plans, subscription trends, and customer insights.
                                                    </p>
                                                </div>
                                            </NavDropdown.Item>

                                            {/* Payment History */}
                                            <NavDropdown.Item
                                                active={location.pathname === "/payment_history"}
                                                onClick={() => {
                                                    navigate("/payment_history");
                                                    dispatch(setAiModal(false));
                                                }}
                                                className="mega-menu-item"
                                            >
                                                <div className="menu-icon">
                                                    <i className="bx bx-wallet-alt"></i>
                                                </div>

                                                <div className="menu-content">
                                                    <h6>Payment History</h6>

                                                    <p>
                                                        Track transactions, invoices, refunds, and revenue history.
                                                    </p>
                                                </div>
                                            </NavDropdown.Item>

                                            {/* User Activity */}
                                            <NavDropdown.Item
                                                active={location.pathname === "/user_activity"}
                                                onClick={() => {
                                                    navigate("/user_activity");
                                                    dispatch(setAiModal(false));
                                                }}
                                                className="mega-menu-item"
                                            >
                                                <div className="menu-icon">
                                                    <i className="bx bx-user-pin"></i>
                                                </div>

                                                <div className="menu-content">
                                                    <h6>User Activity</h6>

                                                    <p>
                                                        Monitor logins, searches, feature usage, and user engagement.
                                                    </p>
                                                </div>
                                            </NavDropdown.Item> 

                                            {/* Default Provider */}
                                            <NavDropdown.Item
                                                active={location.pathname === "/default-provider"}
                                                onClick={() => {
                                                    navigate("/default-provider");
                                                    dispatch(setAiModal(false));
                                                }}
                                                className="mega-menu-item"
                                            >
                                                <div className="menu-icon">
                                                    <i className="bx bx-slider-alt"></i>
                                                </div>

                                                <div className="menu-content">
                                                    <h6>Default Provider</h6>

                                                    <p>
                                                        Primary data source for searches & enrichment.
                                                    </p>
                                                </div>
                                            </NavDropdown.Item>
                                        </>
                                    )}
                                    {(roles?.toLowerCase() !== "super_admin") && (
                                        <>
                                            {/* Trash */}
                                            <NavDropdown.Item
                                                active={location.pathname === "/trash"}
                                                onClick={() => {
                                                    navigate("/trash");
                                                    dispatch(setAiModal(false));
                                                }}
                                                className="mega-menu-item"
                                            >
                                                <div className="menu-icon danger">
                                                    <i className="bx bx-trash"></i>
                                                </div>

                                                <div className="menu-content">
                                                    <h6>Trash</h6>
                                                    <p>View and restore deleted records and manage discarded data.</p>
                                                </div>
                                            </NavDropdown.Item>

                                            {/* Users */}
                                            <NavDropdown.Item
                                                active={location.pathname === "/users"}
                                                onClick={() => {
                                                    navigate("/users");
                                                    dispatch(setAiModal(false));
                                                }}
                                                className="mega-menu-item"
                                            >
                                                <div className="menu-icon primary">
                                                    <i className="bx bx-group"></i>
                                                </div>

                                                <div className="menu-content">
                                                    <div className="menu-header">
                                                        <h6>Users</h6>
                                                        <span className="menu-badge">Admin</span>
                                                    </div>

                                                    <p>Manage user accounts, roles, permissions, and access.</p>
                                                </div>
                                            </NavDropdown.Item>
                                        </>
                                    )}

                                </NavDropdown>

                                {!isAiOpen && <button onClick={connectAI} id="connectAiBtn">
                                    AI Assistant
                                </button>}

                                <Nav.Link onClick={handleProfileToggle} className="p-0">
                                    <div className='header-profile-div' style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
                                        <img
                                            src={profileImg}
                                            alt="Profile"
                                            style={{ height: "30px", width: '30px', borderRadius: '50%', marginRight: '10px' }}
                                        />
                                        <div className='header-user-name'>
                                            <span>{signInDetails[0]?.name}</span>
                                            <p style={{ margin: 0 }}>{signInDetails[0]?.email}</p>
                                        </div>
                                    </div>
                                </Nav.Link>

                                <NavDropdown
                                    title=""
                                    id="profileDropdown"
                                    className="profile-dropdown"
                                    show={showProfileDropdown}
                                    onMouseLeave={() => setShowProfileDropdown(false)}
                                >
                                    <NavDropdown.Item
                                        onClick={() => {
                                            navigate("/profile");
                                            dispatch(setAiModal(false));
                                        }}
                                    >
                                        <span className="menu-icon profile">
                                            <i className="bx bx-user"></i>
                                        </span>
                                        <div className="menu-text">
                                            <span>Profile</span>
                                            <small>Manage your profile</small>
                                        </div>
                                    </NavDropdown.Item>

                                    <NavDropdown.Item
                                        onClick={() => {
                                            navigate("/accounts");
                                            dispatch(setAiModal(false));
                                        }}
                                    >
                                        <span className="menu-icon account">
                                            <i className="bx bx-id-card"></i>
                                        </span>
                                        <div className="menu-text">
                                            <span>Account</span>
                                            <small>Account settings</small>
                                        </div>
                                    </NavDropdown.Item>

                                    <NavDropdown.Item
                                        onClick={() => {
                                            navigate("/reset-password");
                                            dispatch(setAiModal(false));
                                        }}
                                    >
                                        <span className="menu-icon password">
                                            <i className="bx bx-lock-alt"></i>
                                        </span>
                                        <div className="menu-text">
                                            <span>Change Password</span>
                                            <small>Update your password</small>
                                        </div>
                                    </NavDropdown.Item>

                                    <NavDropdown.Divider />

                                    <NavDropdown.Item
                                        className="logout-item"
                                        onClick={openLoguutModal}
                                    >
                                        <span className="menu-icon logout">
                                            <i className="bx bx-log-out"></i>
                                        </span>
                                        <div className="menu-text">
                                            <span>Logout</span>
                                            <small>Sign out securely</small>
                                        </div>
                                    </NavDropdown.Item>
                                </NavDropdown>

                                {/* <NavDropdown
                                    title=""
                                    id="profileDropdown"
                                    className="settingsNavDropdown"
                                    show={showProfileDropdown}
                                    onMouseLeave={() => setShowProfileDropdown(false)}
                                >
                                    <NavDropdown.Item onClick={() => { navigate("/profile"); dispatch(setAiModal(false)) }}>
                                        <i className="fas fa-user fs-16 me-1"></i>
                                        Profile
                                    </NavDropdown.Item>
                                    <NavDropdown.Item onClick={() => { navigate("/accounts"); dispatch(setAiModal(false)) }}>
                                        <i className="bx bx-user-circle fs-16 me-1"></i>
                                        Account
                                    </NavDropdown.Item>

                                    <NavDropdown.Item onClick={() => { navigate("/reset-password"); dispatch(setAiModal(false)) }}>
                                        <i className="fas fa-key fs-16 me-1"></i>
                                        Change Password
                                    </NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item onClick={openLoguutModal}><i className="fas fa-sign-out-alt fs-16 me-1"></i>Logout</NavDropdown.Item>
                                </NavDropdown> */}
                            </div>
                        </Navbar.Collapse>
                    )}
                </Container>
            </Navbar>

            {/* Logout modal */}
            <Modal show={modalShow} onHide={handleModalClose}
                className='saved-search-modal'>
                <Modal.Body>
                    <div>
                        <img src={logOutImg} alt="" className='logout_img' />
                        <h6 className='logout_text'>Are you sure you want to log out? We'll be right here when you get back.</h6>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <ClearBtn btnName='No, Stay' onClickEffect={handleModalClose} />
                    <SearchBtn btnName='Yes, Logout' onClickEffect={logOutPage} />
                </Modal.Footer>
            </Modal>
            {/* Logout modal */}
        </>
    );
};

export default AppNavbar;
